<template>
    <div>
        <template v-for="(item, index) in items" :key="item.key">
            <slot v-bind="{item, visible: index < minVisibleItems || !collapsed}" />
        </template>
        <template v-if="items.length > minVisibleItems">
            <LinkButton v-if="collapsed" :data-testid="`${dataTestidPrefix}-more-button`" @click.prevent="collapsed = false">
                {{ $t('search.filters.see.more.default.label', [items.length - minVisibleItems]) }}
            </LinkButton>
            <LinkButton v-else :data-testid="`${dataTestidPrefix}-less-button`" @click.prevent="collapsed = true">
                {{ $t('search.filters.see.more.toggled.label') }}
            </LinkButton>
        </template>
    </div>
</template>

<script setup lang="ts" generic="T extends {key: string}">
    import {ref} from 'vue';
    import LinkButton from '~/components/common/LinkButton.vue';

    defineProps<{
        dataTestidPrefix: string;
        // Readonly so that lists exposed by a store through readonlyState can be passed as is
        items: readonly T[];
        minVisibleItems: number;
    }>();

    const collapsed = ref(true);
</script>
